import { Typography, Box } from "@mui/material";

import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";
import React from "react";
import RouteConstants from "../../constants/RouteConstant";
const useStyles = makeStyles({
	nopointer: {
		mx: 2,
		textDecoration: "none",
	},
});
export const Footer = () => {
	const classes = useStyles();

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: { xs: "column", md: "row-reverse" },
				justifyContent: "space-between",
				height: "50px",
				mx: { xs: 2, md: 5 },
				// py: { xs: 2 },
				alignItems: "center",
				background: "#121926",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
				}}
			>
				<Link
					color={"#D0D0D1"}
					to={RouteConstants.PRIVACY}
					className={classes.nopointer}
				>
					<Typography
						color="initial"
						fontSize={14}
						paddingX={2}
						color={"#D0D0D1"}
					>
						Privacy Statement
					</Typography>
				</Link>
				<Link
					color="black"
					to={RouteConstants.CONTACT}
					className={classes.nopointer}
				>
					<Typography color="initial" fontSize={14} color={"#D0D0D1"}>
						Contact Us
					</Typography>
				</Link>
			</Box>
			<Box>
				<Typography fontSize={14} fontWeight={400} color={"#D0D0D1"}>
					Copyright &copy; 2022 Ecom Insider.
				</Typography>
			</Box>
		</Box>
	);
};
